import React from 'react';
import IndiaDynamicContent from './IndiaDynamicContent';
import FooterSection from './FooterSection';
import PLBottomBar from './PLBottomBar';
import { PerformanceLabInternationalPricingCallout } from './PerformanceLabInternationalPricingCallout';
import { inter, jetbrainsMono } from 'utils/fonts';
import { PerformanceLabNavbar } from '../../PerformanceLabNavbar';
import { FloatingBookVisitCTA } from '../../FloatingBookVisitCTA';
import styles from './IndiaPerformanceLabsPage.module.css';

const IndiaPerformanceLabsPage: React.FC = () => {
  return (
    <>
      <div
        id="performance-labs-buy-india"
        className={`${styles.pageWrapper} ${inter.variable} ${jetbrainsMono.variable}`}
      >
        <PerformanceLabNavbar />
        <PerformanceLabInternationalPricingCallout />
        <FloatingBookVisitCTA />
        <IndiaDynamicContent />
        <FooterSection />
      </div>
      <PLBottomBar />
    </>
  );
};

export default IndiaPerformanceLabsPage;
